<template>
  <div>
    <mdb-view>
      <mdb-mask class="gradient d-flex justify-content-center align-items-center">
        <mdb-container>
          <mdb-row>
            <div
              class="white-text text-center text-md-left col-md-6 mt-xl-5 mb-5 animated fadeInLeft"
            >
              <h1
                class="h1-responsive font-weight-bold mt-sm-5"
              >Approfondissez vos relations</h1>
              <hr class="hr-light" />
              <h6 class="mb-4">
                Utilisez l'application
                <strong>Please be true</strong> pour mieux communiquer, et pour se concentrer sur la relation à l'autre afin de vivre pleinement.
              </h6>
              <mdb-btn class="orange darken-1" rounded @click="goToLogin">Créer un compte gratuit</mdb-btn>
            </div>
            <mdb-col md="6" xl="5" class="mt-xl-5 animated fadeInRight">
              <video class="video-fluid z-depth-1" autoplay controls muted>
                <source src="@/assets/Please be true.mp4" type="video/mp4" />
              </video>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </mdb-view>
    <mdb-container>
    <section class="my-5">
      <h2 class="h1-responsive font-weight-bold text-center my-5">Pourquoi créer un compte?</h2>
      <p class="lead grey-text w-responsive text-center mx-auto mb-5">Please be true est une plateforme qui favorise certaines bonnes pratiques de communications afin de se sentir bien dans ses relations.</p>
      <mdb-row>
        <mdb-col md="4" class="md-0 mb-5">
          <mdb-row>
            <mdb-col lg="10" md="9" size="10">
              <mdb-icon far icon="laugh-beam" size="2x" class="orange-text"/>
              <h4 class="font-weight-bold">Risque de gens heureux</h4>
              <p class="grey-text">Parler de ses émotions, et écouter attentivement l'autre pour comprendre ce qu'il ressent peut contribuer au bonheur.</p>
            </mdb-col>
          </mdb-row>
        </mdb-col>
        <mdb-col md="4" class="md-0 mb-5">
          <mdb-row>
            <mdb-col lg="10" md="9" size="10">
              <mdb-icon icon="tachometer-alt" size="2x" class="orange-text"/>
              <h4 class="font-weight-bold">Multi-plateformes</h4>
              <p class="grey-text">L'application est utilisable sur tous les supports, et téléchargeable pour une utilisation offline, synchronisée dès que la connection est rétablie...</p>              
            </mdb-col>
          </mdb-row>
        </mdb-col>
        <mdb-col md="4" class="md-0 mb-5">
          <mdb-row>
            <mdb-col lg="10" md="9" size="10">
              <mdb-icon icon="euro-sign" size="2x" class="orange-text"/>
              <h4 class="font-weight-bold">C'est gratuit</h4>
              <p class="grey-text">Et non, vous n'êtes pas le produit, et il n'y a pas de publicités. On fonctionne par donations. On sera heureux si vous souhaitez nous offrir un café :) sinon, vous serez heureux d'utiliser un service gratuit.</p>             
            </mdb-col>
          </mdb-row>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol, mdbView, mdbMask, mdbIcon } from "mdbvue";
export default {
  name: "About",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbView,
    mdbMask,
    mdbIcon
  },
  methods: {
    goToLogin: function() {
      if (!this.$store.state.db.user) this.$router.push({ name: "login" });
      else this.$router.push({ name: "home" });
    }
  }
};
</script>
<style lang="scss" scoped>
.appBtn {
  margin: 50px;
}
.view {
  background-image: url("../assets/background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh - 60px);
}
.gradient {
  background: -moz-linear-gradient(
    45deg,
    rgba(129, 129, 129, 0.7),
    rgba(73, 73, 73, 0.7) 100%
  );
  background: -webkit-linear-gradient(
    45deg,
    rgba(129, 129, 129, 0.7),
    rgba(73, 73, 73, 0.7) 100%
  );
  background: -webkit-gradient(
    linear,
    45deg,
    rgba(129, 129, 129, 0.7),
    rgba(73, 73, 73, 0.7) 100%
  );
  background: -o-linear-gradient(
    45deg,
    rgba(129, 129, 129, 0.7),
    rgba(73, 73, 73, 0.7) 100%
  );
  background: linear-gradient(
    45deg,
    rgba(129, 129, 129, 0.7),
    rgba(73, 73, 73, 0.7) 100%
  );
}
h6 {
  line-height: 1.7;
}
</style>